import Panel from '../components/panel'
import {Button} from '../components/button'
import PropertyInput from "../components/inputs/input-property.tsx";

import { useStore } from "../state/state.ts";

import ModalConfirmButton from '../components/modal_close_button.tsx';

export default function ModalHeizung() {
    const pop_modal = useStore((state)=>state.pop_modal);
    const close_menu = useStore((state) => state.close_menu);
    const api_recalculate = useStore((state) => state.api_recalculate);
    const init_property_if_undefined = useStore((state) => state.init_property_if_undefined);
  return (<Panel >
            <h1 id="modal-title">Welche Heizung wird genutzt?</h1>
            <PropertyInput type="heizung"/>
            <PropertyInput type="heizung_datum"/>
            <PropertyInput placeholder_prefix="z.B." type="energie_kosten_current"/>

           <ModalConfirmButton  onClick={()=>{
                close_menu();
                init_property_if_undefined("heizung");
                api_recalculate();
                pop_modal();
            }}/>
         </Panel>)
}

